import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoSolicitudPrestacionesEspeciales = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoSolicitudPrestacionesEspeciales = () => {
  const [loadingGetInfoSolicitudPrestacionesEspeciales, setLoadingGetInfoSolicitudPrestacionesEspeciales] = useState(false);
  const [successGetInfoSolicitudPrestacionesEspeciales, setSuccessGetInfoSolicitudPrestacionesEspeciales] = useState(false);
  const [errorGetInfoSolicitudPrestacionesEspeciales, setErrorGetInfoSolicitudPrestacionesEspeciales] = useState<any>(null);
  const [dataGetInfoSolicitudPrestacionesEspeciales, setDataGetInfoSolicitudPrestacionesEspeciales] = useState<any>(null);

  const [statusGetInfoSolicitudPrestacionesEspeciales, setStatusGetInfoSolicitudPrestacionesEspeciales] =
    useState<StatusGetInfoSolicitudPrestacionesEspeciales>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudPrestacionesEspeciales = async (
    userId: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoSolicitudPrestacionesEspeciales(true);
    setSuccessGetInfoSolicitudPrestacionesEspeciales(false);
    setErrorGetInfoSolicitudPrestacionesEspeciales(null);

    try {
      const res = await apiRecord.getInfoSolicitudComisionPrestacionesEspeciales(userId);

      setStatusGetInfoSolicitudPrestacionesEspeciales({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoSolicitudPrestacionesEspeciales(true);
      setDataGetInfoSolicitudPrestacionesEspeciales(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;
    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetInfoSolicitudPrestacionesEspeciales({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoSolicitudPrestacionesEspeciales(err);
      console.error("Error en getInfoSolicitudPrestacionesEspeciales:", err);

      throw err;

    } finally {
      setLoadingGetInfoSolicitudPrestacionesEspeciales(false);
    }
  };

  return {
    getInfoSolicitudPrestacionesEspeciales,
    loadingGetInfoSolicitudPrestacionesEspeciales,
    successGetInfoSolicitudPrestacionesEspeciales,
    errorGetInfoSolicitudPrestacionesEspeciales,
    dataGetInfoSolicitudPrestacionesEspeciales,
    statusGetInfoSolicitudPrestacionesEspeciales
  };
};

export default useGetInfoSolicitudPrestacionesEspeciales;
